import { Injectable } from "@angular/core";
import { FamilyInfoDto, NewBornCreateDto, NewbornViewDto, PatientsDto } from "./patientsDto";
import { DateHelper } from "../../../shared/helpers/date-helper";
import { PageData2 } from "../../../shared/models/page-data";
import { WebApiClient } from "../../web-api-client.service";
import { WebApiService } from "../../web-api.service";
import { PatientEditOption } from "./patient-edit-option";
import { ContactDto } from "./contactDto";
import { RegisterEditDto } from "../register/RegisterEditDto";
import { isNullOrUndefined, onGetDateString } from "src/app/shared/utilities";
import { SexEnum } from "src/app/enums/SexEnum";
import { MarriedEnum } from "src/app/enums/MarriedEnum";
import { WholeHistPatientsDto } from "../hist/whole-hist";
import { SupernumeraryTooth, ToothManualAnnotationMap } from "../../../hist/models/tooth-treat-position";

export class BasicPatientDataQuery {
  ClinicId: number;
  PatientNo: number;
  Name: string;
  Birthday: Date | string;
  PhoneNo: string;
  Mobile: string;
  CId: string;
  FullAddress: string;
  PageNumber: number;
  PageSize: number;
  SearchType: string;
  Regdate: Date | string;
  Sex: number;
};

export class GetAllQuery {
  Birthday: Date | string;
  PatientNo: string;
  Name: string;
  PhoneNo: string;
  Mobile: string;
  CId: string;
  Address: string;
  Family?: string;
  SearchType: string;
  PatientId: number;
  FuzzyQuery?: string;
  FieldsToCheck?: string;
}
export class PatientPresDto {
  PreDate: string;
  PreTimes: number;
  PreTotal: number
  Days: number
  DxCode: string;
  DxName: string;
  ICNo: string;
}
export class PatientListDto {
  Id: number;
  PatientNo: string;
  Kcstmr: string;
  LastName: string;
  FirstName: string;
  MiddleName: string;
  PhoneArea: string;
  Phone: string;
  PhoneNo: string;
  Mobile: string;
  Birthday: Date;
  CId: string;
  City: string;
  State: string;
  Area: string;
  Street: string;
  FullName: string;
  Address: string;
  Name: string;
  PaySysA: string;
  Sex: SexEnum;
  RegDate?: Date;
  DiscountId?: number;
  ICode?: string;
  ICno: string;
  IType?: string;
  People?: number;
  RegDates?: Date[];
  FirstDate?: Date;
  RoomCode?: string;
  DxName?: string;
  ZipCode?: string;
  times?: number;
  days?: number;
  DiscountCode?: string;
  NeedToCheckCName?: boolean;
  Age: number;
  LastDate?: Date;
  MonParentsCId: string;
  MonParentsDueDate?: Date;
  BirthsNum?: number;
  ContactName: string;
  ContactRelationCode: string;
  IsAboriginal: boolean;
  Family?: string;
  Married?: MarriedEnum;
  EducationCode: string;
  AgeYear?: number;
  AgeMonth?: number;
  DoctorName?: string;
}

export class PatientNIISDto {
  Id: number;
  PatientNo: string;
  LastName: string;
  Birthday: Date;
  CId: string;
  Name: string;
}

export class PatientResult {
  Data: PageData2<PatientListDto>;
  RowNumber: number;
}

export interface PatientDisabilityDto {
  Id?: number;
  ClinicId?: number;
  PatientId: number;
  PatientNo: string;
  DisabilityCategories?: string;
  DisabilityScores?: string;
  SpecialRequirements?: string;
  ImageUrl?: string;
  MatchedDisabilityTypeCodes?: string;
  ComputedMultipleDisabilityScore?: string;
  Registeries?: string;
  CreateTime?: Date | string;
  EditTime?: Date | string;
}

export interface PatientDentalChartDto {
  PatientId: number;
  SchemaVersion: number;
  Annotations: ToothManualAnnotationMap;
  SupernumeraryTeeth: SupernumeraryTooth[];
  EditTime?: Date | string;
}

@Injectable({ providedIn: 'root' })
export class PatientApi {
  apiService: WebApiService;
  /**
   *
   */
  constructor(private apiClient: WebApiClient) {
    this.apiService = this.apiClient.createHisService('patients/patient');
  }

  Create(model: PatientsDto) {
    model.Birthday = onGetDateString(model.Birthday);
    return this.apiService.post(`Create`, model).toPromise<PatientsDto>();
  }

  CreateContact(model: ContactDto) {
    return this.apiService.post(`CreateContact`, model).toPromise<ContactDto>();
  }

  async Get(id: number) {
    return await this.apiService.get(`Get/${id}`).toPromise<PatientsDto>();
  }

  CheckExist(cId: string) {
    return this.apiService.get(`CheckExist/${cId}`).toPromise<number>();
  }

  // 檢查登入之診所是否有此病歷
  async CheckExistPatient(cId: string) {
    return await this.apiService.get(`CheckExistPatient/${cId}`).toPromise<number>();
  }

  // 列印病歷首頁
  getPatientForPrint(cId: string) {
    return this.apiService.get(`GetPatientForPrint/${cId}`).toPromise<number>();
  }

  GetRand(): Promise<PatientsDto> {
    return this.apiService.get(`GetRand`).toPromise<PatientsDto>();
  }

  GetNotRand(cid: string): Promise<PatientsDto> {
    return this.apiService.get(`GetNotRand/${cid}`).toPromise<PatientsDto>();
  }
  GetPatientByCIdAsync(cid: string): Promise<PatientsDto> {
    return this.apiService.get(`GetPatientByCIdAsync/${cid}`).toPromise<PatientsDto>();
  }
  GetAll(query: GetAllQuery) {
    // 直接轉成ISO日期
    query.Birthday = query.Birthday ? DateHelper.getIsoStringNoTimeZone(new Date(query.Birthday)) : "";
    console.log('GetAll query:', query);
    return this.apiService.get(`GetAll`, query).toPromise<PatientResult>();
  }

  // GetAll(pNo: string,name: string, phone: string, mobile: string, cId: string, address: string, birth: Date|string){
  //     return this.apiService.get(`GetAll?patientNo=${pNo}&name=${name}&phoneNo=${phone}&mobile=${mobile}&cId=${cId}&fullAddress=${address}&birthday=${birth}`).toPromise<PageData>();
  // }
  GetRegister(date: Date, patientId: number) {
    const query = {
      // 當天，時間都轉換為ISO格式再回傳Server
      regDate: date == null ? undefined : DateHelper.getIsoStringNoTimeZone(date),
      patientId: patientId
    };
    return this.apiService.get('GetRegList', query).toPromise<RegisterEditDto[]>();
  }

  Update(model: PatientsDto) {
    return this.apiService.put(`Update`, model).toPromise<PatientsDto>();
  }

  UpdateNewbornNote(pid: number, cid: string, cName: string) {
    const query = {
      pid: pid,
      cid: cid,
      cName: cName
    };
    return this.apiService.get('UpdateNewbornNote', query).toPromise<boolean>();
  }

  UpdatePaySysA(model: PatientListDto) {
    return this.apiService.put(`UpdatePaySysA`, model).toPromise<PatientsDto>();
  }

  UpdatePatientName(id: number, newName: string) {
    var ret = this.apiService.put(`UpdatePatientName?id=` + id + `&newName=` + encodeURIComponent(newName ?? ''), null, true).toPromise();
    return ret;
  }

  UpdatePatientBirthday(id: number, bday: string) {
    var ret = this.apiService.put(`UpdatePatientBirthday?id=` + id + `&bday=` + encodeURIComponent(bday ?? ''), null, true).toPromise();
    return ret;
  }

  UpdatePatientBasicFromRegister(id: number, name: string, bday: string, kcstmr: string) {
    var ret = this.apiService.put(`UpdatePatientBasicFromRegister?id=` + id
      + `&name=` + encodeURIComponent(name ?? '')
      + `&bday=` + encodeURIComponent(bday ?? '')
      + `&kcstmr=` + encodeURIComponent(kcstmr ?? ''), null, false).toPromise();
    return ret;
  }

  UpdatePatientCheckNameFlag(id: number, needToCheck: boolean) {
    var ret = this.apiService.put(`UpdatePatientCheckNameFlag?id=` + id + `&needToCheck=` + needToCheck, null, true).toPromise();
    return ret;
  }

  GetEditOption() {
    return this.apiService.get('getEditOptions').toPromise<PatientEditOption>()
  }

  Delete(id: number) {
    return this.apiService.delete(`Delete/${id}`).toPromise<PatientsDto>();
  }

  GetPresInfo(patientId: number): Promise<PatientPresDto> {
    return this.apiService.get(`GetPresInfo?patientId=${patientId}`, {}).toPromise<PatientPresDto>();
  }

  CheckCIdDuplicated(patientId: number, cId: string): Promise<PatientPresDto> {
    return this.apiService.get(`CheckCIdDuplicated?patientId=${patientId}&cid=${cId}`, {}).toPromise<PatientPresDto>();
  }

  CheckCIdDuplicatedWithoutPatientNo(cId: string): Promise<Boolean> {
    return this.apiService.get(`CheckCIdDuplicatedWithoutPatientNo?cid=${cId}`, {}).toPromise<Boolean>();
  }

  async PreviewPatientNo(): Promise<string> {
    var ret = await this.apiService.get('PreviewPatientNo').toPromise<{ PatientNo: string }>();
    return ret.PatientNo;
  }

  CheckPatientNoExist(patientNo: string): Promise<boolean> {
    return this.apiService.get(`CheckPatientNoExist?patientNo=${patientNo}`, {}).toPromise<boolean>();
  }

  async SaveNewBorn(data: NewBornCreateDto): Promise<number> {
    return this.apiService.post('SaveNewBorn', data).toPromise<number>();
  }

  async GetNewBornList(pid: number): Promise<NewbornViewDto[]> {
    return this.apiService.get('GetNewBornList?pid=' + pid).toPromise<NewbornViewDto[]>();
  }

  async GetLastSeqNo(pid: number): Promise<{ Isqno: string }> {
    return this.apiService.get('GetLastSeqNo?patientId=' + pid).toPromise<{ Isqno: string }>();
  }

  async GetListRowNumber(savePatientNo: string, query: GetAllQuery) {
    if (!query) query = new GetAllQuery();
    query.Birthday = query.Birthday ? DateHelper.getIsoStringNoTimeZone(new Date(query.Birthday)) : "";
    return this.apiService.get(`GetListRowNumber/${savePatientNo}`, query).toPromise<number>();
  }

  async GetNotifyUrl(patientId: number) {
    return this.apiService.get(`GetNotifyUrl?patientId=${patientId}`).toPromise<{ url: string, dataUrl: string }>();
  }

  async GetBasicData(startNo: string, endNo: string, sortBy: string, operater: string, ages: string, minAge: string, maxAge: string, remarkOne: string): Promise<PatientListDto[]> {
    const query = {
      startNo: startNo,
      endNo: endNo,
      sortBy: sortBy,
      operater: operater,
      ages: ages,
      minAge: minAge,
      maxAge: maxAge,
      remarkOne: remarkOne
    };
    return this.apiService.get(`GetBasicData`, query).toPromise<PatientListDto[]>();
  }

  async GetByNo(patientNo: string) {
    return this.apiService.get(`GetByNo`, { patientNo: patientNo }).toPromise<PatientsDto>();
  }

  async GetFirstVisitedDates(startDateWith: string, endDateWith: string, sortBy: string): Promise<PatientListDto[]> {
    return this.apiService.get(`GetFirstVisitedDates`, { startDateWith: startDateWith, endDateWith: endDateWith, sortBy: sortBy }).toPromise<PatientListDto[]>();
  }

  async GetPatientDataByDate(startDate: string, endDate: string, roomid: string, doctorid: number): Promise<PatientListDto[]> {
    return this.apiService.get(`GetPatientDataByDate`, { startDate: startDate, endDate: endDate, roomid: roomid, doctorid: doctorid }).toPromise<PatientListDto[]>();
  }
  async GetPatientDataByDateGrouping(startDate: string, endDate: string, roomid: string, doctorid: number): Promise<PatientListDto[]> {
    return this.apiService.get(`GetPatientDataByDateGrouping`, { startDate: startDate, endDate: endDate, roomid: roomid, doctorid: doctorid }).toPromise<PatientListDto[]>();
  }
  async GetPatientDataByPreventiveCare(endDate: string, SeleAge: String): Promise<PatientListDto[]> {
    return this.apiService.get(`GetPatientDataByPreventiveCare`, { endDate: endDate, SeleAge: SeleAge }).toPromise<PatientListDto[]>();
  }
  async GetStatusFinishWithoutPrescriptionReport(startDateWith: string, endDateWith: string, RoomId: string, DoctorId: number, sortBy: string): Promise<PatientListDto[]> {
    return this.apiService.get(`GetStatusFinishWithoutPrescriptionReport`, { startDateWith: startDateWith, endDateWith: endDateWith, RoomId: RoomId, doctorId: DoctorId, sortBy: sortBy }).toPromise<PatientListDto[]>();
  }

  async GetInfoFromFamily(family: string): Promise<FamilyInfoDto> {
    return this.apiService.get(`GetInfoFromFamily`, { family: family }).toPromise<FamilyInfoDto>();
  }

  async GetPatientDisability(patientId: number): Promise<PatientDisabilityDto> {
    return this.apiService.get(`GetPatientDisability`, { patientId: patientId }).toPromise<PatientDisabilityDto>();
  }

  async SavePatientDisability(model: PatientDisabilityDto): Promise<any> {
    return this.apiService.put(`SavePatientDisability`, model).toPromise<any>();
  }

  async GetPatientDentalChart(patientId: number): Promise<PatientDentalChartDto> {
    return this.apiService.get(`GetPatientDentalChart`, { patientId: patientId }).toPromise<PatientDentalChartDto>();
  }

  async SavePatientDentalChart(model: PatientDentalChartDto): Promise<PatientDentalChartDto> {
    return this.apiService.put(`SavePatientDentalChart`, model).toPromise<PatientDentalChartDto>();
  }

  FromRegisterEditDto(patient: RegisterEditDto): PatientListDto {
    if (isNullOrUndefined(patient)) {
      return null;
    }
    return {
      Id: patient.PatientId,
      PatientNo: patient.PatientNo,
      Kcstmr: "",
      LastName: "",
      FirstName: "",
      MiddleName: "",
      PhoneArea: "",
      Phone: "",
      PhoneNo: "",
      Mobile: "",
      Birthday: patient.PatientBirth,
      CId: patient.PatientCId,
      City: "",
      State: "",
      Area: "",
      Street: "",
      FullName: "",
      Address: "",
      Name: patient.PatientFirstName,
      PaySysA: "",
      Sex: patient.PatientSexCode,
      ICno: "",
      Age: 0,
      MonParentsCId: "",
      ContactName: "",
      ContactRelationCode: "",
      IsAboriginal: false,
      EducationCode: ""
    };
  }

  FromWholeHistPatientsDto(patient: WholeHistPatientsDto): PatientListDto {
    if (isNullOrUndefined(patient)) {
      return null;
    }
    return {
      Id: patient.Id,
      PatientNo: patient.PatientNo,
      Kcstmr: "",
      LastName: "",
      FirstName: "",
      MiddleName: "",
      PhoneArea: "",
      Phone: "",
      PhoneNo: "",
      Mobile: "",
      Birthday: patient.Birthday,
      CId: patient.CId,
      City: "",
      State: "",
      Area: "",
      Street: "",
      FullName: "",
      Address: "",
      Name: patient.CName,
      PaySysA: "",
      Sex: patient.Sex,
      ICno: "",
      Age: 0,
      MonParentsCId: "",
      ContactName: "",
      ContactRelationCode: "",
      IsAboriginal: false,
      EducationCode: ""
    };
  }

}
